<section
  class="ticket-silo"
  [attr.data-state]="state()"
  [class.ticket-silo-drag-active]="dragActive()"
  [class.ticket-silo-drop-target]="isDropTarget()"
  [class.ticket-silo-disabled-target]="isDisabledTarget()"
  [class.ticket-silo-invalid-target]="isInvalidTarget()"
  (dragover)="onDragOver($event)"
  (dragenter)="siloDragEntered.emit()"
  (dragleave)="siloDragLeft.emit()"
  (drop)="onDrop($event)"
>
  <header class="ticket-silo-header">
    <h2 class="ticket-silo-heading">
      <button
        type="button"
        class="ticket-silo-toggle"
        [attr.aria-expanded]="!replie()"
        [attr.aria-controls]="listeId"
        [attr.aria-label]="
          (replie() ? 'Déplier ' : 'Replier ') +
          title() +
          ' (' +
          count() +
          ' tickets), ' +
          badgeCount() +
          ' tickets avec des messages non lus'
        "
        [title]="(replie() ? 'Déplier ' : 'Replier ') + title()"
        (click)="basculerRepli()"
      >
        <span class="material-symbols-outlined ticket-silo-chevron" aria-hidden="true">{{
          replie() ? 'chevron_right' : 'expand_more'
        }}</span>
        <span class="ticket-silo-label"
          >{{ title() }}
          <span class="ticket-silo-count" [title]="count() + ' tickets'"
            >({{ countLabel() }})</span
          ></span
        >
        @if (badgeCount() > 0) {
          <span
            class="ticket-silo-badge"
            [title]="badgeCount() + ' tickets avec des messages non lus'"
            [attr.aria-label]="badgeCount() + ' tickets avec des messages non lus'"
            >{{ badgeCountLabel() }}</span
          >
        }
      </button>
    </h2>
    @if (isInvalidTarget() && invalidMessage()) {
      <p class="ticket-silo-invalid-message">{{ invalidMessage() }}</p>
    }
  </header>

  <div class="ticket-silo-list" [id]="listeId" [hidden]="replie()" [attr.aria-busy]="loadingMore()">
    @if (!replie()) {
      @for (ticket of tickets(); track trackByReference($index, ticket)) {
        <app-silo-ticket-item
          [ticket]="ticket"
          [nouveauTicket]="state() === 'nouveau'"
          [draggable]="itemsDraggable()"
          [showSiteName]="showSiteName()"
          (dragStarted)="ticketDragStarted.emit(ticket)"
          (dragEnded)="ticketDragEnded.emit()"
          (ticketClicked)="ticketClicked.emit(ticket)"
        />
      }

      @if (erreur()) {
        <div class="ticket-silo-footer">
          <p role="alert">{{ erreur() }}</p>
          <button
            type="button"
            class="ticket-silo-more"
            [disabled]="loadingMore()"
            (click)="reessayer.emit()"
          >
            {{ loadingMore() ? 'Chargement...' : 'Réessayer' }}
          </button>
        </div>
      }
      @if (hasMore() && !erreur()) {
        <div class="ticket-silo-footer" #finListe>
          <button
            type="button"
            class="ticket-silo-more"
            [disabled]="loadingMore()"
            (click)="loadMore.emit()"
          >
            @if (loadingMore()) {
              <mat-spinner [diameter]="18" aria-hidden="true" />
            }
            {{ loadingMore() ? 'Chargement...' : 'Charger plus de tickets' }}
          </button>
        </div>
      }
    }
  </div>
</section>
